export default function getDelightedURL(from) {
    return `${window.SURVEY_LINK}&from=${encodeURIComponent(from)}`;
}
